import { Heart, Maximize2 } from "lucide-react";

export function FeaturedPhoto({ photo, onOpen, t }) {
  return (
    <div className="container-eden mb-10">
      <button
        type="button"
        onClick={onOpen}
        className="group relative block w-full overflow-hidden rounded-lg border border-eden-border bg-eden-surface text-left transition-[border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-eden-orange focus-visible:outline focus-visible:outline-2 focus-visible:outline-eden-orange"
        aria-label={`${t("gallery_featured_label")}: ${photo.caption || "ampliar"}`}
        data-testid="gallery-featured"
      >
        <div className="grid lg:grid-cols-12">
          <div className="relative aspect-video overflow-hidden lg:col-span-8 lg:aspect-auto lg:max-h-[440px]">
            <img src={photo.url} alt={photo.caption || t("gallery_featured_label")} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-testid="gallery-featured-image" />
            <span className="absolute left-4 top-4 inline-flex items-center gap-2 rounded-full bg-eden-orange px-3 py-1 font-mono text-[11px] uppercase tracking-widest text-eden-bg" data-testid="gallery-featured-badge">{t("gallery_featured_label")}</span>
          </div>
          <div className="flex flex-col justify-between gap-6 p-6 lg:col-span-4 lg:p-8">
            <div>
              <p className="eyebrow mb-3">{t("gallery_featured_eyebrow")}</p>
              <p className="text-xl font-bold leading-snug text-eden-text sm:text-2xl" data-testid="gallery-featured-caption">{photo.caption || t("gallery_featured_fallback")}</p>
              {photo.author && <p className="mt-3 text-sm text-eden-secondary" data-testid="gallery-featured-author">por {photo.author}</p>}
            </div>
            <div className="flex items-center justify-between text-sm text-eden-secondary">
              <span className="inline-flex items-center gap-2" data-testid="gallery-featured-reactions"><Heart size={16} className="text-eden-orange" aria-hidden="true" /> {photo.reactions} {photo.reactions === 1 ? "reação" : "reações"} no Discord</span>
              <span className="inline-flex items-center gap-1 text-xs text-eden-muted"><Maximize2 size={12} aria-hidden="true" /> ampliar</span>
            </div>
          </div>
        </div>
      </button>
    </div>
  );
}
